import { useSuspenseQuery } from '@tanstack/react-query';
import { stationInfoQueryOption } from '../api/station.options';

const useStationInfo = (stationId?: string) => {
	const { data: stationInfo } = useSuspenseQuery(
		stationInfoQueryOption(stationId),
	);

	return {
		stationInfo,
	};
};

export default useStationInfo;
